import React from 'react';
import {Switch, Route} from 'react-router-dom' 
import Home from './components/Home';
import AdminDb from './components/DashboardAdmin';
import WorksFormList from './components/Admin/WorksFormList';
import ReviewsFormList from './components/Admin/ReviewsController/ReviewsFormList';

import Notfound from './components/Notfound'



/**
 * <Route exact path="/authenticationUserAdmin/webServiceLoginAdministration" component={adminDashboard} />
 */
const Routes = ()=>{

    return(
        <Switch>
                <Route exact path="/" component={Home}/>
                <Route exact path="/admin" component={AdminDb}/>
                <Route exact  path='/works/manage' component={WorksFormList}/>
                <Route exact  path='/reviews/manage' component={ReviewsFormList}/>
        </Switch>
    );

}

export default Routes;